'use client'; // Required directive for client components using hooks/context

import React from 'react';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

if (typeof window !== 'undefined') {
  // Ensure this only runs client-side
  const posthogApiKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
  const posthogHost = process.env.REACT_APP_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com';
  const posthogUIHost = 'https://us.posthog.com'; // The  PostHog UI Url

  console.log('[PostHog Debug] Initializing with:', {
    apiKey: posthogApiKey ? '***' + posthogApiKey.slice(-4) : 'missing',
    api_host: posthogHost,
    ui_host: posthogUIHost,
  });

  const options_min = {
    api_host: posthogHost,
    ui_host: posthogUIHost,
  };

  const options_full = {
    api_host: posthogHost,
    ui_host: posthogUIHost,
    capture_pageview: true, // Enable automatic SPA pageview capture
    bootstrap: {
      distinctID: null,
      isIdentifiedID: false,
      featureFlags: {},
    },
    persistence: 'localStorage+cookie',
    enable_recording_console_log: true,
    // Add opt-out default if desired, otherwise it defaults to opted-in until changed
    // opt_out_capturing_by_default: true,
  };

  if (posthogApiKey) {
    posthog.init(posthogApiKey, options_min);
  } else {
    console.error('PostHog API Key (REACT_APP_PUBLIC_POSTHOG_KEY) is not defined.');
  }
}

interface PHProviderProps {
  children: React.ReactNode;
}

export function PHProvider({ children }: PHProviderProps): JSX.Element {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
